<div class="main-error-container">
  <app-error-header></app-error-header>
  <div class="error-container">
    <div class="error-logo-container">
      <div class="error-logo">
        <img src="assets/images/session.png" />
      </div>
    </div>
    <div class="error-details-container">
      <div class="error-details">
        <div class="error-name">Session Expired</div>
        <div class="error-bar"></div>
        <div class="error-desc">Your session has expired due to inactivity. Please log in again.</div>
        <a href="/login"><button class="error-white-btn">Back to Login</button></a>
      </div>
    </div>
  </div>
</div>